import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addUserToFundByLink } from 'services/fund'
import posthog from 'posthog-js'

export default function useSetAddUserByLink() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddNewUserToFundPayload) => {
            return addUserToFundByLink(payload)
        },
        onSuccess: (data) => {
            posthog.capture('fund_joined')
            toast.success('با موفقیت به صندوق اضافه شدید.')
            navigate(-1)
        },
        onError: () => {
            posthog.capture('fund_join_failed')
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
